import { OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
var DatePickerComponent = /** @class */ (function () {
    function DatePickerComponent() {
    }
    DatePickerComponent.prototype.ngOnInit = function () { };
    Object.defineProperty(DatePickerComponent.prototype, "isRequired", {
        get: function () {
            if (this.control.validator) {
                var validator = this.control.validator({});
                if (validator && validator.required) {
                    return true;
                }
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    return DatePickerComponent;
}());
export { DatePickerComponent };
